import BaseModelAPI from '../BaseModelAPI';

export default class SchedulerConfiguration extends BaseModelAPI {
	static entity = 'schedulerconfiguration';
	static entityName = 'schedulerconfiguration';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.intervalTypeId = '';
			this.intervalType = {};
			this.intervalValue = 0;
			this.intervalValue2 = 0;
			this.intervalValue3 = 0;
			this.cronExpression = '';
			this.jobTypeId = '';
			this.jobType = {};
			this.recurringJobId = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}